import { Autocomplete, TextField, createFilterOptions } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { storeLocation } from '../../../../redux/actions/countries'
import { IRootState } from '../../../../redux/types'
import useModalState from '../../hooks/useModalState'
import { AddItemToAutocompleteModal } from './AddItemToAutocompleteModal'

interface ILocation {
  inputName: string
  name: string
  province: any
}

interface ITown {
  id: number
  name: string
  province_id: number
}

const filter = createFilterOptions()

function TownAutocomplete({ value, province, handleInputChange }: any) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { open, openModal, closeModal } = useModalState()
  const { towns } = useSelector((state: IRootState) => state.country)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)
  const [createLocation, setCreateLocation] = useState<ILocation>({
    inputName: '',
    name: '',
    province: null
  })

  const handleClose = () => {
    setCreateLocation({
      inputName: '',
      name: '',
      province: null
    })

    closeModal()
  }

  const handleSubmit = (event: any) => {
    event.preventDefault()
    dispatch(storeLocation(createLocation))

    closeModal()
  }

  const handleAutoCompleteChange = (town: ITown | null) => {
    handleInputChange('town', town)
  }

  return (
    <>
      <AddItemToAutocompleteModal<ILocation>
        open={open}
        value={createLocation}
        setValue={setCreateLocation}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
      />
      <Autocomplete
        id="autocomplete-towns"
        value={value}
        onChange={(_, newValue) => {
          if (typeof newValue === 'string') {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              openModal()
              setCreateLocation({
                inputName: 'town',
                name: newValue,
                province: province
              })
            })
          } else if (newValue?.inputValue) {
            openModal()
            setCreateLocation({
              inputName: 'town',
              name: newValue.inputValue,
              province: province
            })
          } else {
            handleAutoCompleteChange(newValue)
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params)

          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              name: `${t('add')} "${params.inputValue}"`
            })
          }

          return filtered
        }}
        options={province !== null ? towns.filter((town: any) => town.province_id === province.id) : []}
        getOptionLabel={option => {
          // e.g value selected with enter, right from the input
          if (typeof option === 'string') {
            return option
          }
          if (option.inputValue) {
            return option.inputValue
          }
          return option.id !== undefined ? option.name : ''
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => {
          const { key, ...optionProps } = props
          return (
            <li key={key} {...optionProps}>
              {option.name}
            </li>
          )
        }}
        freeSolo
        renderInput={params => (
          <TextField
            {...params}
            error={errorForm.town}
            helperText={msgForm.town}
            label={t('town')}
            variant="filled"
            required
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </>
  )
}

export default TownAutocomplete
